import styled from 'styled-components';
import { iconVariables } from 'styles/icon.variables';
import {
  gutterVariables,
  Heading,
  fontVariables,
  colorsVariables
} from '@trustedshops/tps-seo-shared-frontend-react-components';
import { minWidth } from 'helpers/buildMediaQueries';

export const ShopStatus = styled.div`
  padding: 0 ${gutterVariables.GUTTER};
  margin-bottom: ${gutterVariables.GUTTER_PLUS_HALF};
  font-size: ${fontVariables.SIZE_TEXT_S};
  align-items: start;

  ${minWidth(
    'xl',
    `
    display: grid;
    grid-area: shopStatus;
    grid-template-columns: max-content auto;
    grid-template-rows: auto auto;
    grid-template-areas:
    'ratingAndStars certificateState'
    'ratingNumber certificateState';
    padding: 0 ${gutterVariables.GUTTER_PLUS_HALF};
  `
  )};
`;

export const RatingHeading = styled(Heading)`
  font-size: ${fontVariables.SIZE_TEXT_M};
`;

export const RatingAndStars = styled.div`
  display: grid;
  grid-template-columns: min-content min-content auto;
  grid-template-rows: auto;
  align-items: baseline;
  color: ${colorsVariables.GRAY_800};
  margin-right: 40px;
  justify-content: start;

  ${minWidth(
    'xl',
    `
    grid-area: ratingAndStars;
    justify-content: normal;
  `
  )};

  span {
    &:not(.hls) {
      white-space: nowrap;
    }
  }

  .hls:before {
    line-height: ${iconVariables.LINE_HEIGHT_REGULAR};
  }
`;

export const RatingNumber = styled.span<{ $hasCertification: boolean }>`
  display: block;
  margin-top: ${gutterVariables.GUTTER_ONE_QUARTER};
  color: ${colorsVariables.GRAY_700};
  grid-area: ratingNumber;

  ${(props) =>
    props.$hasCertification &&
    `
    margin-bottom: ${gutterVariables.GUTTER};
    
  ${minWidth(
    'xl',
    `
    margin-bottom: 0;
  `
  )};
  `}
`;

export const MaxMark = styled.span`
  margin-right: ${gutterVariables.GUTTER_HALF};
`;
